export default "__VITE_ASSET__m4qnxg0b__"